<template>
  <b-container id="skill" fluid>
    <h3>
      <b-row no-gutters align-v="center" cols="4">
        <b-col cols="1" @click="onShow" v-b-toggle.collapse-1>
          <font-awesome-icon icon="cog" class="fa-spin" size="xs" v-if="show"/>
          <font-awesome-icon icon="cog" size="xs" v-else/>
        </b-col>
        <b-col class="pt-1" cols="2">
          <span>
          Skills
          </span>
        </b-col>
        <b-col class="pt-1 pl-2" cols="1">
            <b-button class="ml-4 d-none d-md-inline" size="sm" id="button_show" v-b-toggle.collapse-1 variant="light" @click="onShow">{{ showText }}</b-button>
        </b-col>
      </b-row>
    </h3>
    <div class="d-none d-md-inline mx-auto pt-4">
      <b-card-group class="mx-auto" deck >
        <IconCard v-for="(i, ind) in strSlice(0)"  :key="ind" :num="ind" :ics="icns[ind]" :text="i" style="justify-content: center; align-items: center;"/>
      </b-card-group>
      <b-card-group class="mx-auto" deck >
        <IconCard v-for="(i, ind) in strSlice(4)"  :key="ind" :num="ind + 4" :ics="icns[ind + 4]" :text="i" style="justify-content: center; align-items: center;"/>
      </b-card-group>
      <b-card-group class="mx-auto" deck >
        <IconCard v-for="(i, ind) in strSlice(8)"  :key="ind" :num="ind + 8" :ics="icns[ind + 8]" :text="i" style="justify-content: center; align-items: center;"/>
      </b-card-group>
      <b-collapse id="collapse-1" class="mt-2" visible >
        <b-card>
          <span class="mr-3" v-for="t in allCode" :key="t"> {{ t }} </span>
        </b-card>
     </b-collapse>
    </div>
    <div class="p-4 ml-2 d-center d-block d-md-none" >
      <span class="mr-3" v-for="t in allCode" :key="t"> {{ t }} </span>
    </div>
  </b-container>
</template>
<script>
import IconCard from '@/components/subcomponents/IconCard'

export default {
  components: {
    IconCard
  },
  data () {
    return {
      showText: 'Hide',
      show: false,
      strings: {
        web: ['HTML', 'CSS', 'serverless', 'firebase'],
        js: ['javascript', 'node.js', 'typescript'],
        react: ['React'],
        php: ['php', 'laravel'],
        python: ['Django', 'python', 'flask'],
        ruby: ['ruby', 'sinatra', 'puma'],
        embed: ['C', 'RSLogix'],
        db: ['MySQL', 'SQLLite', 'postgres'],
        net: ['C#', 'VB.NET'],
        analytics: ['R', 'Matlab', 'pandas', 'Tableau', 'Alteryx'],
        linux: ['redhat', 'centOS', 'kali', 'openBSD'],
        java: ['Java']
      },
      icns: [
        ['fas', 'laptop-code'],
        ['fab', 'node-js'],
        ['fab', 'react'],
        ['fab', 'laravel'],
        ['fab', 'python'],
        ['fas', 'gem'],
        ['fas', 'microchip'],
        ['fas', 'database'],
        ['fas', 'terminal'],
        ['fas', 'chart-pie'],
        ['fab', 'linux'],
        ['fab', 'java']
      ]
    }
  },
  computed: {
    allCode () {
      return Object.values(this.strings).flat()
    }
  },
  methods: {
    onShow () {
      if (this.show) {
        this.showText = 'Hide'
      } else {
        this.showText = 'Show'
      }
      this.show = !this.show
    },
    strSlice (i) {
      return Object.values(this.strings).slice(i, i + 4)
    }
  }
}

</script>

<style>
#about {
}

.head {
  padding-left: 10px
}
.icons {
  display: flex;
}
</style>
